<route-meta>
{
  "requiresAuth": true
}
</route-meta>

<i18n>
{
  "en": {
    "dashboard" : {
      "title": "Dashboard"
    }
  }
}
</i18n>

<template>
  <div class="home">
    <h1 v-html="$t(`dashboard.title`)"></h1>
    <logs></logs>
  </div>
</template>

<script>
import Logs from './logs';

export default {
  name: 'home',
  components: {
    Logs,
  },
  created() {
    this.$store.dispatch('breadcrumbs/reset');
  },
};
</script>
